import { call, put, select } from 'redux-saga/effects';
import { setSessionSummary } from '../../../state/message/messageSessionSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { backendClient } from '../../../services/api/backend-client';

export function* fetchMessageSummarySaga(action) {
    const { messageSessionId } = action.payload;
    try {
        const { domain, uid, user } = yield select(selectUserCredentials);
        const { data } = yield call(
            [backendClient, backendClient.get],
            `messages/${messageSessionId}/summary?domain=${domain}&user=${user}&userId=${uid}`
        );
        yield put(setSessionSummary({ sessionId: messageSessionId, summary: data.summary }));
    } catch (error) {
        console.error('Error fetching messages:', error);
    }
}